import isNullOrUndefined from "./isNullOrUndefined";

export default function isEmpty(value) {
    if (isNullOrUndefined(value)) return true;
    if (typeof(value) === "string") return value.trim().length === 0;
    if (Array.isArray(value)) return value.length === 0;
    return false;
}
